import Axios from 'axios';
import React, { useMemo, useState } from 'react'
import SaleTotalInfomation from './Components/SaleTotalInfomation';
import CancelTotal from './Components/CancelTotal';
import ItemInfomation from './Components/ItemInfomation';
import ItemSwap from './Components/ItemSwap';
import StoreUserCount from './Components/StoreUserCount';
import DeliveryCount from './Components/DeliveryCount';
import OrderCount from './Components/OrderCount';

const Statitics = () => {

  // 불러온 데이터 저장
  const [data, setData] = useState([]);

  // 데이터 불러오기
  const dataLoade = async ()=>{
    
    await Axios.get(`/api/statitics/dataloade`)
    .then((res)=>{
      setData(res.data);
    })
    .catch((err)=>{
      console.log('오류가 발생했습니다\n', err);
    });

  }

  useMemo(()=>{
    document.title = '통계';

    dataLoade();
  }, [])
  
  return (
    <div className='flex flex-col justify-center items-center'>
      <div className='flex flex-col gap-3 md:max-w-screen-lg 2xl:max-w-screen-2xl w-full rounded-xl p-3'>

        {/* 매장별 판매, 서비스, 시연용 처리 현황 */}
        <div className='grid grid-cols-1 md:grid-cols-4 gap-3'>          
          {/* 탄방 판매 처리 현황 */}
          <SaleTotalInfomation store={ '탄방점' } data={ {
            data0: data[0]?.VALUE ?? 0,
            data1: data[1]?.VALUE ?? 0,
            data2: data[2]?.VALUE ?? 0,
            data3: data[3]?.VALUE ?? 0,
            data4: data[4]?.VALUE ?? 0,
            data5: data[5]?.VALUE ?? 0,
            data6: data[6]?.VALUE ?? 0,
            data7: data[7]?.VALUE ?? 0,
            data8: data[8]?.VALUE ?? 0,
          } } />

          {/* 둔산 판매 처리 현황 */}
          <SaleTotalInfomation store={ '둔산점' } data={ {
            data0: data[9]?.VALUE ?? 0,
            data1: data[10]?.VALUE ?? 0,
            data2: data[11]?.VALUE ?? 0,
            data3: data[12]?.VALUE ?? 0,
            data4: data[13]?.VALUE ?? 0,
            data5: data[14]?.VALUE ?? 0,
            data6: data[15]?.VALUE ?? 0,
            data7: data[16]?.VALUE ?? 0,
            data8: data[17]?.VALUE ?? 0,
          } } />

          {/* 자양 판매 처리 현황 */}
          <SaleTotalInfomation store={ '자양점' } data={ {
            data0: data[18]?.VALUE ?? 0,
            data1: data[19]?.VALUE ?? 0,
            data2: data[20]?.VALUE ?? 0,
            data3: data[21]?.VALUE ?? 0,
            data4: data[22]?.VALUE ?? 0,
            data5: data[23]?.VALUE ?? 0,
            data6: data[24]?.VALUE ?? 0,
            data7: data[25]?.VALUE ?? 0,
            data8: data[26]?.VALUE ?? 0,
          } } />

          {/* 충대 판매 처리 현황 */}
          <SaleTotalInfomation store={ '충대점' } data={ {
            data0: data[27]?.VALUE ?? 0,
            data1: data[28]?.VALUE ?? 0,
            data2: data[29]?.VALUE ?? 0,
            data3: data[30]?.VALUE ?? 0,
            data4: data[31]?.VALUE ?? 0,
            data5: data[32]?.VALUE ?? 0,
            data6: data[33]?.VALUE ?? 0,
            data7: data[34]?.VALUE ?? 0,
            data8: data[35]?.VALUE ?? 0,
          } } />
        </div>

        {/* 알림바 */}
        <div className='bg-gray-500/50 p-3 flex gap-3 rounded-md w-full'>
          <p className='duration-100 animate-pulse'>📢</p>
          <p>〈결제 현황〉은 제품 판매시 결제 방식의 데이터 수집 기능을 나중에 시작하여, 판매 현황과 합이 다릅니다.</p>
        </div>

        {/* 매장별 취소 처리 현황 */}
        <div className='grid grid-cols-1 md:grid-cols-4 gap-3'>
          <CancelTotal store={ '탄방점' } data={ { data0: data[36]?.VALUE ?? 0, data1: data[37]?.VALUE ?? 0, data2: data[132]?.VALUE ?? 0, data3: data[133]?.VALUE ?? 0, }} />
          <CancelTotal store={ '둔산점' } data={ { data0: data[38]?.VALUE ?? 0, data1: data[39]?.VALUE ?? 0, data2: data[134]?.VALUE ?? 0, data3: data[135]?.VALUE ?? 0, }} />
          <CancelTotal store={ '자양점' } data={ { data0: data[40]?.VALUE ?? 0, data1: data[41]?.VALUE ?? 0, data2: data[136]?.VALUE ?? 0, data3: data[137]?.VALUE ?? 0, }} />
          <CancelTotal store={ '충대점' } data={ { data0: data[42]?.VALUE ?? 0, data1: data[43]?.VALUE ?? 0, data2: data[138]?.VALUE ?? 0, data3: data[139]?.VALUE ?? 0, }} />
        </div>

        {/* 매장별 아이템 관리 처리 현황 */}
        <div className='grid grid-cols-1 md:grid-cols-4 gap-3'>
          <ItemInfomation store={ '탄방점' } data={ { data0: data[44]?.VALUE ?? 0, data1: data[45]?.VALUE ?? 0, data2: data[46]?.VALUE ?? 0 }} />
          <ItemInfomation store={ '둔산점' } data={ { data0: data[47]?.VALUE ?? 0, data1: data[48]?.VALUE ?? 0, data2: data[49]?.VALUE ?? 0 }} />
          <ItemInfomation store={ '자양점' } data={ { data0: data[50]?.VALUE ?? 0, data1: data[51]?.VALUE ?? 0, data2: data[52]?.VALUE ?? 0 }} />
          <ItemInfomation store={ '충대점' } data={ { data0: data[53]?.VALUE ?? 0, data1: data[54]?.VALUE ?? 0, data2: data[55]?.VALUE ?? 0 }} />
        </div>

        {/* 매장별 반출 반입 매입 처리 현황 */}
        <div className='grid grid-cols-1 md:grid-cols-4 gap-3'>
          <ItemSwap store={ '탄방점' } data={ { 
            data0: data[56]?.VALUE ?? 0,
            data1: data[57]?.VALUE ?? 0,
            data2: data[58]?.VALUE ?? 0,
            data3: data[59]?.VALUE ?? 0,
            data4: data[60]?.VALUE ?? 0,
            data5: data[61]?.VALUE ?? 0,
            data6: data[62]?.VALUE ?? 0,
            data7: data[63]?.VALUE ?? 0,
          }} />

          <ItemSwap store={ '둔산점' } data={ { 
            data0: data[64]?.VALUE ?? 0,
            data1: data[65]?.VALUE ?? 0,
            data2: data[66]?.VALUE ?? 0,
            data3: data[67]?.VALUE ?? 0,
            data4: data[68]?.VALUE ?? 0,
            data5: data[69]?.VALUE ?? 0,
            data6: data[70]?.VALUE ?? 0,
            data7: data[71]?.VALUE ?? 0,
          }} />

          <ItemSwap store={ '자양점' } data={ { 
            data0: data[72]?.VALUE ?? 0,
            data1: data[73]?.VALUE ?? 0,
            data2: data[74]?.VALUE ?? 0,
            data3: data[75]?.VALUE ?? 0,
            data4: data[76]?.VALUE ?? 0,
            data5: data[77]?.VALUE ?? 0,
            data6: data[78]?.VALUE ?? 0,
            data7: data[79]?.VALUE ?? 0,
          }} />

          <ItemSwap store={ '충대점' } data={ { 
            data0: data[80]?.VALUE ?? 0,
            data1: data[81]?.VALUE ?? 0,
            data2: data[82]?.VALUE ?? 0,
            data3: data[83]?.VALUE ?? 0,
            data4: data[84]?.VALUE ?? 0,
            data5: data[85]?.VALUE ?? 0,
            data6: data[86]?.VALUE ?? 0,
            data7: data[87]?.VALUE ?? 0,
          }} />
        </div>

        {/* 매장별 고객 등록 현황 */}
        <div className='grid grid-cols-1 md:grid-cols-4 gap-3'>
          <StoreUserCount store={ '탄방점' } data={ { data0: data[88]?.VALUE ?? 0 } } />
          <StoreUserCount store={ '둔산점' } data={ { data0: data[89]?.VALUE ?? 0 } } />
          <StoreUserCount store={ '자양점' } data={ { data0: data[90]?.VALUE ?? 0 } } />
          <StoreUserCount store={ '충대점' } data={ { data0: data[91]?.VALUE ?? 0 } } />
        </div>

        {/* 매장별 택배 퀵 등록 현황 */}
        <div className='grid grid-cols-1 md:grid-cols-4 gap-3'>
          <DeliveryCount store={ '탄방점' } data={ { data0: data[92]?.VALUE ?? 0, data1: data[93]?.VALUE ?? 0 } } />
          <DeliveryCount store={ '둔산점' } data={ { data0: data[94]?.VALUE ?? 0, data1: data[95]?.VALUE ?? 0 } } />
          <DeliveryCount store={ '자양점' } data={ { data0: data[96]?.VALUE ?? 0, data1: data[97]?.VALUE ?? 0 } } />
          <DeliveryCount store={ '충대점' } data={ { data0: data[98]?.VALUE ?? 0, data1: data[99]?.VALUE ?? 0 } } />
        </div>

        {/* 매장별 주문요청 처리 현황 */}
        <div className='grid grid-cols-1 md:grid-cols-4 gap-3'>
          <OrderCount store={ '탄방점' } data={ { 
            data0: data[100]?.VALUE ?? 0, 
            data1: data[101]?.VALUE ?? 0, 
            data2: data[102]?.VALUE ?? 0, 
            data3: data[103]?.VALUE ?? 0,
            data4: data[104]?.VALUE ?? 0, 
            data5: data[105]?.VALUE ?? 0, 
            data6: data[106]?.VALUE ?? 0, 
            data7: data[107]?.VALUE ?? 0,
          }} />

          <OrderCount store={ '둔산점' } data={ { 
            data0: data[108]?.VALUE ?? 0, 
            data1: data[109]?.VALUE ?? 0, 
            data2: data[110]?.VALUE ?? 0, 
            data3: data[111]?.VALUE ?? 0,
            data4: data[112]?.VALUE ?? 0, 
            data5: data[113]?.VALUE ?? 0, 
            data6: data[114]?.VALUE ?? 0, 
            data7: data[115]?.VALUE ?? 0,
          }} />

          <OrderCount store={ '자양점' } data={ { 
            data0: data[116]?.VALUE ?? 0, 
            data1: data[117]?.VALUE ?? 0, 
            data2: data[118]?.VALUE ?? 0, 
            data3: data[119]?.VALUE ?? 0,
            data4: data[120]?.VALUE ?? 0, 
            data5: data[121]?.VALUE ?? 0, 
            data6: data[122]?.VALUE ?? 0, 
            data7: data[123]?.VALUE ?? 0,
          }} />

          <OrderCount store={ '충대점' } data={ { 
            data0: data[124]?.VALUE ?? 0, 
            data1: data[125]?.VALUE ?? 0, 
            data2: data[126]?.VALUE ?? 0, 
            data3: data[127]?.VALUE ?? 0,
            data4: data[128]?.VALUE ?? 0, 
            data5: data[129]?.VALUE ?? 0, 
            data6: data[130]?.VALUE ?? 0, 
            data7: data[131]?.VALUE ?? 0,
          }} />
        </div>

      </div>
    </div>
  )
}

export default Statitics